import { CONTAINER_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Header heading element for the feature banner component',
  extends: [pick(CONTAINER_ARGS, [{ name: 'tag', default: 'h1' }])],
  name: 'Feature Banner Header',
});

export default class SpdsFeedbackFeatureBannerHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-feature-banner-header';

  get tag() {
    return this.argOrDefault('tag');
  }

  <template>
    <FlexRow
      @tag={{this.tag}}
      class={{this.classes}}
      data-test-spds-feedback-feature-banner-header
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const FEATURE_BANNER_HEADER_METADATA = SpdsFeedbackFeatureBannerHeader.metadata;
